import React, { useContext, useEffect, useRef, useState, useCallback, useMemo } from "react";

import { useHistory, useParams } from "react-router-dom";

import {
  Button,
  Grid,
  Paper,
  Tab,
  Tabs,
  Switch,
  FormControlLabel,
  Tooltip,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { UsersFilter } from "../../components/UsersFilter";
import api from "../../services/api";
import * as chatService from '../../services/chatService';
import toastError from '../../errors/toastError';
import ChatList from "./ChatList";
import ChatMessages from "./ChatMessages";
import ChatHeader from "../../components/ChatHeader";
import ChatInfoModal from "../../components/ChatInfoModal";
import ModernChatList from "../../components/ModernChatList";
import ModernChatMessages from "../../components/ModernChatMessages";
import ModernChatModal from "../../components/ModernChatModal";
import MessageSearch from "../../components/MessageSearch";
// import { SocketContext } from "../../context/Socket/SocketContext";

// ✅ Novo sistema de gestão de estado
import { useChatReducer, chatSelectors } from "../../hooks/useChatReducer";

import { has, isObject } from "lodash";

import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flex: 1,
    padding: 0, // ✅ Removido padding para visual moderno
  height: "100%",
    overflowY: "hidden",
    backgroundColor: theme.palette.background.default,
  },
  mainContainerHorizontal: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flex: 1,
    padding: 0, // ✅ Removido padding para visual moderno
    height: `calc(100% - 48px)`,
    overflowY: "hidden",
    backgroundColor: theme.palette.background.default,
  },
  gridContainer: {
    flex: 1,
    height: "100%",
    backgroundColor: theme.palette.background.default,
  },
  gridItem: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  gridItemTab: {
    height: "92%",
    width: "100%",
  },
  btnContainer: {
    padding: "16px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },  // ✅ Novos estilos para layout moderno
  chatSidebar: {
    borderRight: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    borderRadius: 12, // ✅ Cantos arredondados
    marginRight: 6, // ✅ Apenas margem direita pequena
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)", // ✅ Sombra sutil
    overflow: "hidden", // ✅ Para manter o borderRadius
    width: "320px", // ✅ Largura fixa para a sidebar
    minWidth: "300px", // ✅ Largura mínima
    maxWidth: "400px", // ✅ Largura máxima
    flexShrink: 0, // ✅ Impede que a sidebar encolha
  },
  chatMainArea: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: theme.palette.background.default,
    overflow: "hidden", // ✅ Prevenir overflow que pode esconder o header
    borderRadius: 12, // ✅ Cantos arredondados
    marginLeft: 6, // ✅ Apenas margem esquerda pequena
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)", // ✅ Sombra sutil
    flex: 1, // ✅ Ocupa o espaço restante
    minWidth: 0, // ✅ Permite que o flex funcione corretamente
  },  modernChatContainer: {
    display: "flex",
    height: "100%",
    backgroundColor: theme.palette.background.default,
    padding: "12px", // ✅ Padding de 12px para criar o espaçamento interno
    gap: "0", // ✅ Sem gap, as margens dos filhos criam o espaçamento
    boxSizing: "border-box", // ✅ Incluir padding no cálculo da largura
  width: '100%',
  overflowX: 'hidden', // ✅ Evitar scroll horizontal no layout moderno
  // ✅ Evitar gestos horizontais e preparar safe-area somente em mobile
  touchAction: 'pan-y',
  overscrollBehaviorX: 'contain',
  maxWidth: '100%',
  '--safe-area': '0px',
  "@supports (padding-bottom: env(safe-area-inset-bottom))": {
    '--safe-area': 'env(safe-area-inset-bottom)'
  },
  "@supports (padding-bottom: constant(safe-area-inset-bottom))": {
    '--safe-area': 'constant(safe-area-inset-bottom)'
  },
  },
  welcomeArea: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    padding: theme.spacing(4),
    textAlign: "center",
    backgroundColor: theme.palette.background.paper,
    backgroundImage: `linear-gradient(45deg, ${theme.palette.background.paper} 25%, transparent 25%), 
                     linear-gradient(-45deg, ${theme.palette.background.paper} 25%, transparent 25%), 
                     linear-gradient(45deg, transparent 75%, ${theme.palette.background.paper} 75%), 
                     linear-gradient(-45deg, transparent 75%, ${theme.palette.background.paper} 75%)`,
    backgroundSize: '20px 20px',
    backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
  },
}));

function Chat(props) {
  const classes = useStyles();
  const { user, socket, isHorizontal } = useContext(AuthContext);
  const history = useHistory();

  // ✅ Novo sistema de gestão de estado unificado
  const [state, actions] = useChatReducer();
  
  // ✅ Estados que permanecem como useState (específicos da UI)
  const [showDialog, setShowDialog] = useState(false);
  const [dialogType, setDialogType] = useState("new");
  const [useModernUI, setUseModernUI] = useState(true);
  // ✅ Refs e outros estados locais
  const isMounted = useRef(true);
  const scrollToBottomRef = useRef();
  const typingTimeouts = useRef(new Map()); // ✅ Timeouts para limpeza automática de typing
    // ✅ Destructuring do estado para facilitar o uso
  const {
    chats,
    messages,
    currentChat,
    messagesPageInfo,
    chatsPageInfo,
    messagesPage,
    loading,
    tab,
    showSearch,
    showChatInfo,
    highlightedMessage,
    typingUsers,
    typingUsersData, // ✅ Adicionar typingUsersData para ModernChatList
    chatLastViewed,
    editingMessage,
    deletingMessage
  } = state;
  const { id } = useParams();

  // ✅ Filtrar typingUsersData para excluir o próprio usuário
  const filteredTypingUsersData = useMemo(() => {
    return Array.from(typingUsersData).filter(typingUser => typingUser.userId !== user.id);
  }, [typingUsersData, user.id]);

  // ✅ Nova função para atualização otimista
  const handleUpdateChat = useCallback((updatedChat) => {
    // console.log('🔄 [ChatPage] Atualização otimista recebida:', updatedChat);
    actions.updateChat(updatedChat);
  }, [actions]); // ✅ `actions` é estável e não causa recriação  // ✅ Funções de manipulação de chat
  const handleSelectChat = (chat) => {
    selectChat(chat);
    history.push(`/chats/${chat.uuid}`);
  };

  const handleEditChat = (chat) => {
    selectChat(chat); // Garante que o chat a ser editado é o atual
    setDialogType("edit");
    setShowDialog(true);
  };

  const handleDeleteChat = async (chat) => {
    try {
      // TODO: Adicionar um modal de confirmação antes de deletar
      await api.delete(`/chats/${chat.id}`);
      // A atualização da UI é tratada pelo evento de socket 'onChat' com action 'delete'
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);  // ✅ Carregar timestamps de visualização quando usuário estiver disponível
  useEffect(() => {
    if (user?.id) {
      try {
        const saved = localStorage.getItem(`chatLastViewed_${user.id}`);
        if (saved) {
          actions.setChatLastViewed(JSON.parse(saved));
        }
      } catch (err) {
        // console.error('Erro ao carregar timestamps de visualização:', err);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]); // ✅ CORREÇÃO: Removido 'actions' das dependências

  // ✅ Salvar timestamps de visualização no localStorage
  useEffect(() => {
    if (user?.id && Object.keys(chatLastViewed).length > 0) {
      try {
        localStorage.setItem(`chatLastViewed_${user.id}`, JSON.stringify(chatLastViewed));
      } catch (err) {
        // console.error('Erro ao salvar timestamps de visualização:', err);
      }
    }
  }, [chatLastViewed, user?.id]);

  useEffect(() => {
    if (!isMounted.current) return;
    
    const loadInitialData = async () => {
      try {
        const data = await findChats();
        if (!data || !data.records) return;
          const { records } = data;
        actions.setChats(records);
        actions.setChatsPageInfo(data);

        // ✅ Navegação segura para chat específico
        if (id && records.length > 0) {
          const targetChat = records.find((r) => r.uuid === id);
          if (targetChat) {
            actions.selectChat(targetChat);
          } else {
            // console.warn(`Chat com UUID ${id} não encontrado`);
            history.push("/chats"); // ✅ Redireciona se chat não existe
          }
        }
      } catch (err) {
        // console.error("Erro ao carregar dados iniciais:", err);
      }
    };    loadInitialData();
    }, [id]); 

  // ✅ Listener para tecla ESC para fechar chat
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && currentChat?.id) {
        // ✅ Verificar se não há gravação ativa ou preview de áudio
        const recordingElement = document.querySelector('[class*="recordingInterface"]');
        const audioPreviewElement = document.querySelector('[class*="audioPreview"], .audio-preview, [class*="recordedAudio"]');
        
        if (!recordingElement && !audioPreviewElement) {
          actions.selectChat({});
          history.push("/chats");
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [currentChat?.id, actions, history]);
  
  useEffect(() => {
    if (isObject(currentChat) && has(currentChat, "id")) {
      actions.findMessages(currentChat.id).then(() => {
        if (typeof scrollToBottomRef.current === "function") {
          setTimeout(() => {
            scrollToBottomRef.current();
          }, 300);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentChat.id]); // ✅ CORREÇÃO: Removido 'actions' das dependências  // ✅ Funções de callback estáveis para listeners de socket
  const onChatUser = useCallback((data) => {
    // console.log('📨 Evento recebido onChatUser:', data); // ✅ Debug
    
    // ✅ Log específico para eventos de typing
    if (data.action === "user-typing") {
      // console.log('🔍 onChatUser - Evento de typing detectado:', {
      //   action: data.action,
      //   chatId: data.chatId,
      //   userId: data.userId,
      //   userName: data.userName,
      //   isTyping: data.isTyping,
      //   currentUserId: user.id
      // });
    }
        if (data.action === "create") {
        actions.addChat(data.record);
      }
      if (data.action === "update") {
        actions.updateChat(data.record);
        if (currentChat.id === data.record.id) {
          actions.selectChat(data.record);
        }
      }
      // ✅ Adicionar nova mensagem em tempo real (otimizado)
      if (data.action === "new-message") {
        // console.log('� [onChatUser] Nova mensagem recebida:', {
        //   messageId: data.newMessage.id,
        //   chatId: data.newMessage.chatId,
        //   senderId: data.newMessage.senderId,
        //   currentChatId: currentChat.id,
        //   currentUserId: user.id
        // });        
        // ✅ Só adiciona mensagens se for do chat atual
        if (data.newMessage.chatId === currentChat.id) {
          // ✅ Evita duplicatas verificando se mensagem já existe
          const messageExists = messages.some(msg => msg.id === data.newMessage.id);
          if (!messageExists) {
            // console.log('✅ Adicionando nova mensagem ao estado (onChatUser)');
            actions.addMessage(data.newMessage);
          } else {
            // console.log('⚠️ Mensagem já existe, ignorando duplicata (onChatUser)');
          }
        } else {
          // console.log('ℹ️ Mensagem de outro chat, não adicionando à lista de mensagens (onChatUser)');
        }
          // ✅ Atualizar chat que recebeu a mensagem
        const isFromCurrentUser = data.newMessage.senderId === user.id;
        const isCurrentChat = currentChat.id === data.newMessage.chatId;
        
        // ✅ Usar os dados de unreads vindos do backend em vez de calcular manualmente
        // console.log(`📊 [onChatUser] Nova mensagem recebida - usando dados do backend:`, {
        //   chatId: data.chat?.id,
        //   currentUserUnreads: data.chat?.users?.find(u => u.userId === user.id)?.unreads
        // });
        
        const updatedChatData = {
          ...data.chat,
          lastMessage: data.chat.lastMessage,
          lastMessageSenderId: data.newMessage.senderId,
          updatedAt: data.chat.updatedAt
        };
        
        actions.updateChatAndReorder(updatedChatData);
        
        // ✅ Scroll suave e otimizado apenas para mensagens do chat atual
        if (data.newMessage.chatId === currentChat.id && typeof scrollToBottomRef.current === "function") {
          requestAnimationFrame(() => {
            scrollToBottomRef.current();
          });
        }
      }
        // ✅ Atualizar reações de mensagens (otimizado)
      if (data.action === "message-reaction") {
        const updatedMessage = messages.find(msg => msg.id === data.messageId);
        if (updatedMessage) {
          actions.updateMessage({ ...updatedMessage, reactions: data.reactions });
        }
      }
      
      // ✅ Atualizar status de leitura de mensagens em tempo real
      if (data.action === "message-read") {
  // console.log('👁️ Status de leitura atualizado:', data); // ✅ Debug
        const updatedMessage = messages.find(msg => msg.id === data.messageId);
        if (updatedMessage) {
          actions.updateMessage({ 
            ...updatedMessage, 
            readAt: data.readAt,
            readBy: data.readBy 
          });
        }
      }        // ✅ Gerenciar eventos de atualização de chats (pin, mute, archive)
      if (data.action === "chat-updated") {
  // console.log('🔄 Chat atualizado em tempo real:', data);
        const chatToUpdate = chats.find(chat => chat.id === data.chatId);
        if (chatToUpdate) {
          let updatedChat = { ...chatToUpdate };            if (data.updateType === 'pin') {
              updatedChat.isPinned = data.isPinned;
            } else if (data.updateType === 'mute') {
              updatedChat.isMuted = data.isMuted;
              updatedChat.mutedUntil = data.mutedUntil;
            } else if (data.updateType === 'archive') {
              updatedChat.isArchived = data.isArchived;
            }
            
            actions.updateChat(updatedChat);
          }
        }
        // ✅ Eventos específicos de pin/mute/archive vindos do backend
      if (data.action === "pin-chat" || data.action === "unpin-chat") {
  // console.log('📌 Evento de pin/unpin recebido:', data);
        const updatedChat = { 
          ...data.chat, 
          isPinned: data.action === "pin-chat"
        };
        actions.updateChat(updatedChat);
      }
      
      if (data.action === "mute-chat" || data.action === "unmute-chat") {
  // console.log('🔇 Evento de mute/unmute recebido:', data);
        const updatedChat = { 
          ...data.chat, 
          isMuted: data.action === "mute-chat",
          mutedUntil: data.mutedUntil || null
        };
        actions.updateChat(updatedChat);
      }
      
      if (data.action === "archive-chat" || data.action === "unarchive-chat") {
  // console.log('📦 Evento de archive/unarchive recebido:', data);
        const updatedChat = { 
          ...data.chat, 
          isArchived: data.action === "archive-chat"
        };
        actions.updateChat(updatedChat);
      }        // ✅ Gerenciar usuários digitando (excluir o próprio usuário)
      if (data.action === "user-typing") {
        // ✅ Só processar se não for o próprio usuário
        if (data.userId !== user.id) {
          // console.log(`⌨️ ${data.userName} ${data.isTyping ? 'começou' : 'parou'} de digitar (ID: ${data.userId} vs próprio: ${user.id})`);
          
          const typingKey = `${data.chatId}-${data.userId}`;
          
          if (data.isTyping) {
            // ✅ Adicionar usuário digitando
            actions.setTypingUser(data.chatId, data.userId, data.userName, data.isTyping);
            
            // ✅ Limpar timeout anterior se existir
            if (typingTimeouts.current.has(typingKey)) {
              clearTimeout(typingTimeouts.current.get(typingKey));
            }
            
            // ✅ Configurar timeout para remover automaticamente após 5 segundos
            const timeoutId = setTimeout(() => {
              // console.log(`⏰ Timeout: Removendo ${data.userName} automaticamente após 5s`);
              actions.setTypingUser(data.chatId, data.userId, data.userName, false);
              typingTimeouts.current.delete(typingKey);
            }, 5000);
            
            typingTimeouts.current.set(typingKey, timeoutId);
          } else {
            // ✅ Remover usuário que parou de digitar
            actions.setTypingUser(data.chatId, data.userId, data.userName, data.isTyping);
            
            // ✅ Limpar timeout se existir
            if (typingTimeouts.current.has(typingKey)) {
              clearTimeout(typingTimeouts.current.get(typingKey));
              typingTimeouts.current.delete(typingKey);
            }
          }
        } else {
          // console.log(`🚫 Ignorando typing do próprio usuário: ${data.userName} (ID: ${data.userId})`);
        }
      }// ✅ Edição de mensagem em tempo real
      if (data.action === "edit-message") {
  // console.log('✏️ [onChatUser] Mensagem editada:', data.message);
  // console.log('✏️ [onChatUser] Estado atual das mensagens:', messages.length);
        actions.updateMessage(data.message);
  // console.log('✅ [onChatUser] Mensagem editada aplicada');
      }

      // ✅ Exclusão de mensagem em tempo real
      if (data.action === "delete-message") {
  // console.log('🗑️ [onChatUser] Mensagem deletada:', data.messageId);
  // console.log('🗑️ [onChatUser] Estado atual das mensagens:', messages.length);
  actions.deleteMessage(data.messageId);        // console.log('✅ [onChatUser] Mensagem deletada aplicada');
      }
  }, [actions, messages, currentChat.id, user.id, chats, typingTimeouts]);

  const onChat = useCallback((data) => {
  // console.log('📨 Evento recebido onChat:', data); // ✅ Debug
      
      if (data.action === "delete") {
        actions.removeChat(+data.id);
        actions.setMessages([]);
        actions.setMessagesPage(1);
        actions.setMessagesPageInfo({ hasMore: false });
        actions.selectChat({});
        history.push("/chats");
      }
      
      if (data.action === "update") {
        // console.log('🔄 [onChat] Chat atualizado:', data.chat?.id);
        // console.log('📊 [onChat] Dados do chat:', {
          // chatId: data.chat?.id,
          // usersCount: data.chat?.users?.length,
          // currentUserUnreads: data.chat?.users?.find(u => u.userId === user.id)?.unreads
        // });
        
        if (data.chat) {
          actions.updateChat(data.chat);
        }
      }
      
      if (data.action === "new-message") {
  // console.log('📬 [onChat] Nova mensagem recebida:', data.chat?.id);
        if (data.chat) {
          actions.updateChat(data.chat);        }
      }
  }, [actions, user.id, history]);

  // ✅ Registra listeners de socket em useEffect
  useEffect(() => {
    // ✅ Registra listeners apenas uma vez por usuário
    const userChannel = `company-${user.companyId}-chat-user-${user.id}`;
    const chatChannel = `company-${user.companyId}-chat`;
    
  // console.log(`🔔 Registrando listener para: ${userChannel}`);
  // console.log(`🔔 Registrando listener para: ${chatChannel}`);    
    socket.on(userChannel, onChatUser);
    socket.on(chatChannel, onChat);
    
    // ✅ Listener genérico para broadcast de mensagens
    const onChatMessage = (data) => {
      // console.log('📨 Evento chat-message recebido:', data);
      if (data.action === "message-read") {
        // console.log('👁️ Status de leitura via chat-message:', data);
        const updatedMessage = messages.find(msg => msg.id === data.messageId);
        if (updatedMessage) {
          actions.updateMessage({ 
            ...updatedMessage, 
            readAt: data.readAt,
            readBy: data.readBy 
          });
        }
      }
    };
    
    socket.on("chat-message", onChatMessage);

    // ✅ Listener adicional para eventos de leitura globais
    const onMessageRead = (data) => {
      // console.log('👁️ Evento message-read global recebido:', data);
      if (data.action === "message-read") {
        const updatedMessage = messages.find(msg => msg.id === data.messageId);
        if (updatedMessage) {
          // console.log(`👁️ Atualizando status de leitura da mensagem ${data.messageId}`);
          actions.updateMessage({ 
            ...updatedMessage, 
            readAt: data.readAt,
            readBy: data.readBy 
          });
        }
      }
    };
    
    socket.on("message-read", onMessageRead);
    
    return () => {
      // ✅ Remove listeners do usuário
  // console.log(`🔕 Removendo listeners`);
      socket.off(userChannel, onChatUser);
      socket.off(chatChannel, onChat);
      socket.off("chat-message", onChatMessage);
      socket.off("message-read", onMessageRead);
      
      // ✅ Limpar todos os timeouts de typing
      typingTimeouts.current.forEach(timeoutId => clearTimeout(timeoutId));
      typingTimeouts.current.clear();
    };
  }, [user.companyId, user.id, socket, onChatUser, onChat, actions, messages, typingTimeouts]); // ✅ Dependências corretas

  // ✅ Listener específico do chat atual em useEffect separado
  useEffect(() => {
    if (!isObject(currentChat) || !has(currentChat, "id")) return;

    const companyId = user.companyId;
    const chatId = currentChat.id;

    const onCurrentChat = (data) => {
  // console.log('📨 Evento recebido onCurrentChat:', data); // ✅ Debug
      
      if (data.action === "new-message") {
        // console.log('� [onCurrentChat] Nova mensagem no chat atual:', {
          // messageId: data.newMessage.id,
          // chatId: data.newMessage.chatId,
          // senderId: data.newMessage.senderId,
          // currentChatId: currentChat.id
        // });
          // ✅ Evita duplicatas
        const messageExists = messages.some(msg => msg.id === data.newMessage.id);
        if (!messageExists) {
          // console.log('✅ Adicionando nova mensagem ao chat atual (onCurrentChat)');
          actions.addMessage(data.newMessage);
        } else {
          // console.log('⚠️ Mensagem já existe no chat atual, ignorando duplicata (onCurrentChat)');
        }
        
        // ✅ NÃO atualizar lista de chats aqui - deixar para onChatUser para evitar duplicação
  // console.log('ℹ️ onCurrentChat: Não atualizando lista de chats (evitar duplicação)');
        
        // ✅ Scroll otimizado
        if (typeof scrollToBottomRef.current === "function") {
          requestAnimationFrame(() => {
            scrollToBottomRef.current();
          });
        }
      }      // ✅ Atualizar reações de mensagens no chat atual (otimizado)
      if (data.action === "message-reaction") {
        const updatedMessage = messages.find(msg => msg.id === data.messageId);
        if (updatedMessage) {
          actions.updateMessage({ ...updatedMessage, reactions: [...data.reactions] }); // ✅ Nova referência para trigger re-render
        }
      }      // ✅ Atualizar status de leitura no chat atual
      if (data.action === "message-read") {
  // console.log('👁️ Status de leitura atualizado no chat atual:', data); // ✅ Debug
        const updatedMessage = messages.find(msg => msg.id === data.messageId);
        if (updatedMessage) {
          actions.updateMessage({ 
            ...updatedMessage, 
            readAt: data.readAt,
            readBy: data.readBy 
          });
        }
      }

      // ✅ Tratar edição de mensagem
      if (data.action === "edit-message") {
  // console.log('✏️ Mensagem editada recebida:', data);
        const messageIndex = messages.findIndex(msg => msg.id === data.message.id);
        if (messageIndex !== -1) {
          actions.updateMessage({
            ...messages[messageIndex],
            ...data.message,
            isEdited: true,
            editedAt: data.message.editedAt
          });
          // console.log('✅ Mensagem editada atualizada na UI');
        }
      }

      // ✅ Tratar exclusão de mensagem
      if (data.action === "delete-message") {
  // console.log('🗑️ Mensagem deletada recebida:', data);
        actions.deleteMessage(data.messageId);
  // console.log('✅ Mensagem removida da UI');
      }

      if (data.action === "update") {
        const updatedChat = chats.find(chat => chat.id === data.chat.id);
        if (updatedChat) {
          actions.updateChat({ ...updatedChat, ...data.chat });        }
        // ✅ Verificação segura do scroll
        if (typeof scrollToBottomRef.current === "function") {
          scrollToBottomRef.current();
        }
      }
    };

    socket.on(`company-${companyId}-chat-${chatId}`, onCurrentChat);    return () => {
      socket.off(`company-${companyId}-chat-${chatId}`, onCurrentChat);
    };
  }, [currentChat.id, user.companyId, socket]); // ✅ CORREÇÃO: Removido 'actions', 'messages', 'chats' das dependências
  // Agora sim, fora do useEffect:
  const selectChat = async (chat) => {
  // console.log('🔥 selectChat chamada com:', chat); // Debug
    try {
      // ✅ Validação antes de limpar estado
      if (!chat || !chat.id) {
        // console.error("Chat inválido para seleção");
        return;
      }

      // console.log('📖 Selecionando chat:', chat.id, chat.title); // Debug

      // ✅ Carregar dados completos do chat (incluindo usuários)
      try {
        // console.log('🔍 Carregando dados completos do chat...'); // Debug
        const { data: fullChatData } = await api.get(`/chats/${chat.uuid}`);
        // console.log('🔍 Dados completos do chat:', fullChatData); // Debug
        chat = { ...chat, ...fullChatData }; // Merge dos dados
      } catch (error) {
        // console.warn('⚠️ Erro ao carregar dados completos do chat, usando dados da lista:', error);
      }

      // ✅ Marcar timestamp de visualização do chat
      const now = new Date().toISOString();
      actions.setChatLastViewed({
        ...chatLastViewed,
        [chat.id]: now
      });

      // ✅ Reset estado de forma atômica
      actions.setMessages([]);
      actions.setMessagesPage(1);
      actions.setMessagesPageInfo({ hasMore: false });

      // ✅ Define novo chat por último
  // console.log('🎯 Chamando actions.selectChat...'); // Debug
      actions.selectChat(chat);
      actions.setTab(1);

      // ✅ Marcar mensagens como lidas (resetar contador)
      const updatedChat = { ...chat, unreadCount: 0 };
      actions.updateChat(updatedChat);

      // console.log(`📖 Chat ${chat.id} marcado como visualizado em:`, now);

    } catch (err) {
      // console.error("Erro ao selecionar chat:", err);
    }
  };
  const sendMessage = async (message) => {
    // ✅ Esta função é chamada pelo ModernChatMessages após envio bem-sucedido
    // console.log('🚀 sendMessage chamada com:', message);
    
    // ✅ Adiciona mensagem localmente para feedback imediato
    if (message && message.id) {
      // ✅ Evita duplicatas verificando se mensagem já existe
      const messageExists = messages.some(msg => msg.id === message.id);
      if (!messageExists) {
  // console.log('✅ Adicionando mensagem localmente via sendMessage');
        actions.addMessage(message);
      }
      
      // ✅ Scroll automático
      if (typeof scrollToBottomRef.current === "function") {
        setTimeout(() => {
          scrollToBottomRef.current();
        }, 100);      }
    }
  };

  // ✅ Funções para edição e exclusão de mensagens
  const handleEditMessage = useCallback((editedMessage) => {
    actions.updateMessage(editedMessage);
  }, [actions]);

  const handleDeleteMessage = useCallback((messageId) => {
    actions.deleteMessage(messageId);
  }, [actions]);

  // ✅ Função para controle da busca de mensagens
  const handleSearchToggle = useCallback(() => {
    actions.toggleSearch();
  }, [actions]);
  // ✅ Funções para controle do modal de informações do chat
  const handleChatInfoToggle = useCallback(() => {
    actions.toggleChatInfo();
  }, [actions]);

  // ✅ Função para fechar chat atual
  const handleCloseChat = useCallback(() => {
    // Limpar chat atual e redirecionar para a lista
    actions.selectChat({});
    history.push("/chats");
  }, [actions, history]);

  const handleChatUpdate = useCallback((updatedChat) => {
    actions.updateChat(updatedChat);
  }, [actions]);
  const handleMessageSelect = useCallback((message) => {
    // ✅ Fecha a busca primeiro
    if (showSearch) {
      actions.toggleSearch();
    }
    
    // ✅ Destaca a mensagem
    actions.setHighlightedMessage(message.id);
    
    // ✅ Remove o destaque após 3 segundos
    setTimeout(() => {
      actions.setHighlightedMessage(null);
    }, 3000);
  }, [actions, showSearch]);

  const deleteChat = async (chat) => {
    try {
      await api.delete(`/chats/${chat.id}`);
    } catch (err) {
      // console.error("Erro ao deletar chat:", err);
      toastError(err);
    }
  };

  // ✅ Função para fixar/desfixar chat
  const handlePinChat = async (chat) => {
    try {
      // console.log('📌 Fixando/desfixando chat:', chat.id);
      
      // ✅ Determinar novo estado (inverter atual ou definir padrão)
      const currentPinned = Boolean(chat.isPinned);
      const newPinnedState = !currentPinned;
      
      const response = await chatService.pinChat(chat.id, newPinnedState);
        if (response.data && response.data.success) {
        // ✅ Atualizar lista de chats localmente
        const updatedChats = chats.map(c => 
          c.id === chat.id 
            ? { ...c, isPinned: response.data.chatUser.isPinned }
            : c
        );
        
        // ✅ Reorganizar: chats fixados no topo
        const sortedChats = updatedChats.sort((a, b) => {
          // Primeiro ordenar por status de fixado
          if (a.isPinned && !b.isPinned) return -1;
          if (!a.isPinned && b.isPinned) return 1;
          
          // Depois ordenar por data de atualização
          const dateA = new Date(a.updatedAt);
          const dateB = new Date(b.updatedAt);
          return dateB - dateA;
        });
        
        actions.setChats(sortedChats);
        
        // console.log(`✅ Chat ${response.data.chatUser.isPinned ? 'fixado' : 'desfixado'} com sucesso`);
      }
    } catch (err) {
      // console.error("Erro ao fixar/desfixar chat:", err);      
      toastError(err);
    }
  };

  // ✅ Função para silenciar/dessilenciar chat
  const handleMuteChat = async (chat, duration = null) => {
    try {
      // console.log('🔇 Silenciando/dessilenciando chat:', chat.id, 'duration:', duration);
      // console.log('🔇 Estado atual do chat:', { isMuted: chat.isMuted, mutedUntil: chat.mutedUntil });
      
      // ✅ Determinar novo estado (inverter atual ou definir padrão)
      const currentMuted = Boolean(chat.isMuted);
      const newMutedState = !currentMuted;
      
  // console.log('🔇 Novo estado calculado:', { currentMuted, newMutedState });
      
      // ✅ Calcular mutedUntil se duration foi fornecida
      let mutedUntil = null;
      if (newMutedState && duration) {
        const now = new Date();
        mutedUntil = new Date(now.getTime() + duration * 60 * 1000); // duration em minutos
  // console.log('🔇 mutedUntil calculado:', mutedUntil);
      }
      
      // console.log('🔇 Chamando API com:', { 
      //   chatId: chat.id, 
      //   isMuted: newMutedState, 
      //   mutedUntil 
      // });
      
      const response = await chatService.muteChat(chat.id, newMutedState, mutedUntil);
      
  // console.log('🔇 Resposta da API:', response);
        if (response.data && response.data.success) {        // ✅ Atualizar lista de chats localmente
        const updatedChat = { 
          ...chat, 
          isMuted: response.data.chatUser.isMuted, 
          mutedUntil: response.data.chatUser.mutedUntil
        };
        actions.updateChat(updatedChat);
        
        // console.log(`✅ Chat ${response.data.chatUser.isMuted ? 'silenciado' : 'dessilenciado'} com sucesso`);
      }
    } catch (err) {
      // console.error("Erro ao silenciar/dessilenciar chat:", err);      // console.error("Detalhes do erro:", err.response?.data || err.message);
      toastError(err);
    }
  };

  // ✅ Função para arquivar/desarquivar chat
  const handleArchiveChat = async (chat) => {
    try {
      // console.log('📦 Arquivando/desarquivando chat:', chat.id);
      
      // ✅ Determinar novo estado (inverter atual ou definir padrão)
      const currentArchived = Boolean(chat.isArchived);
      const newArchivedState = !currentArchived;
      
      const response = await chatService.archiveChat(chat.id, newArchivedState);
        if (response.data && response.data.success) {
        // ✅ Atualizar lista de chats localmente
        const updatedChat = { ...chat, isArchived: response.data.chatUser.isArchived };
        actions.updateChat(updatedChat);
          // ✅ Se foi arquivado e é o chat atual, limpar seleção
        if (response.data.chatUser.isArchived && currentChat.id === chat.id) {
          actions.selectChat({});
          actions.setMessages([]);
          actions.setMessagesPage(1);
          actions.setMessagesPageInfo({ hasMore: false });
          history.push("/chats");
        }
        
        // console.log(`✅ Chat ${response.data.chatUser.isArchived ? 'arquivado' : 'desarquivado'} com sucesso`);
      }
    } catch (err) {
      // console.error("Erro ao arquivar/desarquivar chat:", err);
      toastError(err);
    }
  };
  const findMessages = async (chatId) => {
    actions.setLoading(true);
    try {
      const { data } = await api.get(
        `/chats/${chatId}/messages?pageNumber=${messagesPage}`
      );
      actions.setMessagesPageInfo(data);
      actions.addMessages(data.records);
      actions.setMessagesPage(messagesPage + 1); // ✅ Só incrementa se sucesso
    } catch (err) {
      // console.error("Erro ao carregar mensagens:", err);
      // TODO: Adicionar toast de erro para o usuário
    }
    actions.setLoading(false);
  };

  const loadMoreMessages = async () => {
    // ✅ Previne múltiplas chamadas e verifica se há mais mensagens
    if (loading || !messagesPageInfo.hasMore || !currentChat.id) return;
    
    try {
      await findMessages(currentChat.id);
    } catch (err) {
      // console.error("Erro ao carregar mais mensagens:", err);
    }
  };

  const findChats = async () => {
    try {
      const { data } = await api.get("/chats");
      return data;
    } catch (err) {
      // console.log(err);
    }
  };
  // ✅ Função para calcular mensagens não lidas de cada chat
  const calculateUnreadCount = (chat) => {
    // console.log(`🔍 calculateUnreadCount para chat ${chat.id}:`, {
      // chatId: chat.id,
      // currentChatId: currentChat.id,
      // backendUnreadCount: chat.unreadCount,
      // lastMessage: chat.lastMessage,
      // lastMessageSenderId: chat.lastMessageSenderId,
      // userId: user.id,
      // updatedAt: chat.updatedAt,
      // lastViewed: chatLastViewed[chat.id],
      // isMuted: chat.isMuted,
      // mutedUntil: chat.mutedUntil
    // });
    
    // ✅ Se for o chat atual, não tem mensagens não lidas (está visualizando)
    if (currentChat.id === chat.id) {
  // console.log(`📖 Chat ${chat.id} é o atual - contador: 0`);
      return 0;
    }
    
    // ✅ Se o chat está silenciado, não mostrar contador
    if (chat.isMuted) {
      // ✅ Verificar se ainda está no período de silenciamento
      if (chat.mutedUntil) {
        const now = new Date();
        const mutedUntil = new Date(chat.mutedUntil);
        if (now < mutedUntil) {
          // console.log(`🔇 Chat ${chat.id} está silenciado até ${chat.mutedUntil} - contador: 0`);
          return 0;
  } else {          // console.log(`🔊 Chat ${chat.id} saiu do período de silenciamento`);
          // ✅ Atualizar automaticamente o status de silenciamento expirado
          const updatedChat = { ...chat, isMuted: false, mutedUntil: null };
          actions.updateChat(updatedChat);
        }
      } else {
  // console.log(`🔇 Chat ${chat.id} está permanentemente silenciado - contador: 0`);
        return 0;
      }
    }
    
    // ✅ Primeiro, tentar usar o unreadCount do backend se disponível
    if (chat.unreadCount !== undefined && chat.unreadCount > 0) {
  // console.log(`📖 Chat ${chat.id} usando unreadCount do backend: ${chat.unreadCount}`);
      return chat.unreadCount;
    }
    
    // ✅ Se não tem última mensagem, não há nada para ler
    if (!chat.lastMessage) {
  // console.log(`📖 Chat ${chat.id} sem última mensagem - contador: 0`);
      return 0;
    }
    
    // ✅ Se a última mensagem foi enviada pelo próprio usuário, não conta como não lida
    if (chat.lastMessageSenderId === user.id) {
  // console.log(`📖 Chat ${chat.id} última mensagem é própria - contador: 0`);
      return 0;
    }
    
    // ✅ Verificar se o chat foi visualizado após a última mensagem
    const lastViewed = chatLastViewed[chat.id];
    if (lastViewed) {
      const lastViewedDate = new Date(lastViewed);
      const lastMessageDate = new Date(chat.updatedAt);
      
  // console.log(`📖 Chat ${chat.id} - Última visualização: ${lastViewed}, Última mensagem: ${chat.updatedAt}`);
      
      // ✅ Se foi visualizado após a última atualização, não há mensagens não lidas
      if (lastViewedDate >= lastMessageDate) {
  // console.log(`📖 Chat ${chat.id} visualizado após última mensagem - contador: 0`);
        return 0;
      }
    }
      // ✅ Como fallback, assumir 1 mensagem não lida
  // console.log(`📖 Chat ${chat.id} fallback - contador: 1`);
    return 1;
  };

  // ✅ Organizar chats: fixados no topo, depois normais, arquivados separados
  const chatsWithUnreadCount = chats
    .filter(chat => !chat.isArchived) // ✅ Excluir arquivados da lista principal
    .map(chat => ({
      ...chat,
      unreadCount: calculateUnreadCount(chat),
      currentUserId: user.id
    }))
    .sort((a, b) => {
      // ✅ Primeiro: chats fixados sempre no topo
      if (a.isPinned && !b.isPinned) return -1;
      if (!a.isPinned && b.isPinned) return 1;
      
      // ✅ Segundo: ordenar por data de atualização (mais recente primeiro)
      const dateA = new Date(a.updatedAt);
      const dateB = new Date(b.updatedAt);
      return dateB - dateA;
    });
  // ✅ Chats arquivados para menu colapsável
  const archivedChats = chats
    .filter(chat => chat.isArchived)
    .map(chat => ({
      ...chat,
      unreadCount: calculateUnreadCount(chat),
      currentUserId: user.id
    }))
    .sort((a, b) => {
      const dateA = new Date(a.updatedAt);
      const dateB = new Date(b.updatedAt);
      return dateB - dateA;
    });

  // ✅ Função para salvar dados do modal
  const handleModalSave = async (formData) => {
    try {
      if (dialogType === "edit") {
        await api.put(`/chats/${currentChat.id}`, {
          users: formData.users,
          title: formData.title,
        });
        // Atualizar chat atual se necessário
        actions.updateChat({ ...currentChat, title: formData.title });
      } else {
        const { data } = await api.post("/chats", {
          users: formData.users,
          title: formData.title,
        });
        
        // ✅ Reset completo de estado antes de definir novo chat
        actions.setMessages([]);
        actions.setMessagesPage(1);
        actions.setMessagesPageInfo({ hasMore: false });
        actions.selectChat(data);
        actions.setTab(1);
        
        // ✅ Atualiza lista de chats se necessário
        const exists = chats.find(chat => chat.id === data.id);
        if (!exists) {
          actions.addChat(data);
        }
        
        history.push(`/chats/${data.uuid}`);
      }
    } catch (err) {
      // console.error("Erro ao salvar chat:", err);
      throw err; // Re-throw para que o modal possa lidar com o erro
    }
  };

  const renderGrid = () => {
    // ✅ Renderiza UI moderna ou clássica baseado no toggle
    if (useModernUI) {
      return (
        <div className={classes.modernChatContainer}>
          {/* ✅ Sidebar com lista de chats moderna */}
          <div className={classes.chatSidebar}>             <ModernChatList
              chats={chats}
              selectedChatId={currentChat?.uuid}
              typingUsers={filteredTypingUsersData} // ✅ Usar versão filtrada (sem o próprio usuário)
              onChatSelect={handleSelectChat}
              onChatEdit={handleEditChat}
              onChatDelete={handleDeleteChat}
              onUpdateChat={handleUpdateChat} // ✅ Passando a prop para atualização otimista
              onNewChatClick={() => {
                setDialogType("new");
                setShowDialog(true);
              }} // ✅ Nova prop para criar novo chat
              loading={loading && chats.length === 0}
            />
          </div>

          {/* ✅ Área principal do chat */}
          <div className={classes.chatMainArea}>
            {isObject(currentChat) && has(currentChat, "id") ? (
              <>
                {/* ✅ Header moderno do chat */}                <ChatHeader 
                  chat={currentChat}
                  onSearchClick={handleSearchToggle}
                  onVideoCall={() => {/* console.log('Chamada de vídeo') */}}
                  onPhoneCall={() => {/* console.log('Chamada de voz') */}}
                  onMenuClick={() => {/* console.log('Menu do chat') */}}
                  onHeaderClick={handleChatInfoToggle}
                  onClose={handleCloseChat}
                  isSearchOpen={showSearch}
                />
                
                {/* ✅ Componente de busca de mensagens */}
                {showSearch && (
                  <MessageSearch
                    chatId={currentChat.id}
                    onResultClick={handleMessageSelect}
                    onClose={() => actions.toggleSearch()}
                    isOpen={showSearch}
                  />
                )}                  {/* ✅ Área de mensagens modernas */}
                <ModernChatMessages
                  chat={currentChat}
                  messages={messages}
                  typingUsers={typingUsers} // ✅ Passar typingUsers global
                  handleSendMessage={sendMessage}
                  handleLoadMore={loadMoreMessages}
                  scrollToBottomRef={scrollToBottomRef}
                  pageInfo={messagesPageInfo}
                  loading={loading}
                  isSearchOpen={showSearch}
                  onSearchToggle={handleSearchToggle}
                  onMessageHighlight={actions.setHighlightedMessage}
                  highlightedMessageId={highlightedMessage}
                  editingMessage={editingMessage}
                  onEditMessage={handleEditMessage}
                  onDeleteMessage={handleDeleteMessage}
                  onSetEditingMessage={actions.setEditingMessage}
                />
              </>
            ) : (
              // ✅ Estado quando nenhum chat está selecionado
              <div className={classes.welcomeArea}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  💬 Chat Interno
                </Typography>
                <Typography variant="body1" color="textSecondary">
                  Selecione um chat para começar a conversar
                </Typography>
                <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                  Ou crie um novo chat para iniciar uma conversa
                </Typography>
              </div>
            )}
          </div>
        </div>
      );
    }

    // ✅ UI Clássica (mantém compatibilidade)
    return (
      <Grid className={classes.gridContainer} container>
        <Grid className={classes.gridItem} md={3} item>
          <div className={classes.btnContainer}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Button
                onClick={() => {
                  setDialogType("new");
                  setShowDialog(true);
                }}
                color="primary"
                variant="contained"
                style={{ marginRight: 8 }}
              >
                {i18n.t("chatInternal.new")}
              </Button>
              
              <Tooltip title={useModernUI ? "Usar interface clássica" : "Usar interface moderna"}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={useModernUI}
                      onChange={(e) => setUseModernUI(e.target.checked)}
                      size="small"
                      color="primary"
                    />
                  }
                  label="Moderno"
                  style={{ margin: 0 }}
                />
              </Tooltip>
            </div>
          </div>            <ChatList
            chats={chats}
            pageInfo={chatsPageInfo}
            loading={loading}
            typingUsers={filteredTypingUsersData} // ✅ Usar versão filtrada (sem o próprio usuário)
            handleSelectChat={async (chat) => await selectChat(chat)}
            handleDeleteChat={(chat) => deleteChat(chat)}
            handleEditChat={() => {
              setDialogType("edit");
              setShowDialog(true);
            }}
          />
        </Grid>
        <Grid className={classes.gridItem} md={9} item>
          {isObject(currentChat) && has(currentChat, "id") && (
            <ChatMessages
              chat={currentChat}
              scrollToBottomRef={scrollToBottomRef}
              pageInfo={messagesPageInfo}
              messages={messages}
              loading={loading}
              handleSendMessage={sendMessage}
              handleLoadMore={loadMoreMessages}
            />
          )}
        </Grid>
      </Grid>
    );
  };

  // UI moderna no mobile (uma coluna: lista OU conversa aberta)
  const renderMobile = () => {
    // Quando um chat está selecionado, mostra Header + Mensagens modernas
    if (isObject(currentChat) && has(currentChat, "id")) {
      return (
        <div className={classes.modernChatContainer} style={{ padding: 0 }}>
          <div
            className={classes.chatMainArea}
            style={{ marginLeft: 0, boxShadow: "none", borderRadius: 0 }}
          >
            <ChatHeader
              chat={currentChat}
              onSearchClick={handleSearchToggle}
              onVideoCall={() => {}}
              onPhoneCall={() => {}}
              onMenuClick={() => {}}
              onHeaderClick={handleChatInfoToggle}
              onClose={handleCloseChat}
              isSearchOpen={showSearch}
            />

            {showSearch && (
              <MessageSearch
                chatId={currentChat.id}
                onResultClick={handleMessageSelect}
                onClose={() => actions.toggleSearch()}
                isOpen={showSearch}
              />
            )}

            <ModernChatMessages
              chat={currentChat}
              messages={messages}
              typingUsers={typingUsers}
              handleSendMessage={sendMessage}
              handleLoadMore={loadMoreMessages}
              scrollToBottomRef={scrollToBottomRef}
              pageInfo={messagesPageInfo}
              loading={loading}
              isSearchOpen={showSearch}
              onSearchToggle={handleSearchToggle}
              onMessageHighlight={actions.setHighlightedMessage}
              highlightedMessageId={highlightedMessage}
              editingMessage={editingMessage}
              onEditMessage={handleEditMessage}
              onDeleteMessage={handleDeleteMessage}
              onSetEditingMessage={actions.setEditingMessage}
            />
          </div>
        </div>
      );
    }

    // Sem chat selecionado: exibir lista moderna ocupando toda a largura
    return (
      <div className={classes.modernChatContainer} style={{ padding: 12 }}>
        <div style={{ display: "flex", flexDirection: "column", flex: 1, height: "100%", overflow: "hidden" }}>
          <ModernChatList
            chats={chats}
            selectedChatId={currentChat?.uuid}
            typingUsers={filteredTypingUsersData}
            onChatSelect={handleSelectChat}
            onChatEdit={handleEditChat}
            onChatDelete={handleDeleteChat}
            onUpdateChat={handleUpdateChat}
            onNewChatClick={() => {
              setDialogType("new");
              setShowDialog(true);
            }}
            loading={loading && chats.length === 0}
          />
        </div>
      </div>
    );
  };

  return (
    <>
      <ModernChatModal
        open={showDialog}
        onClose={() => setShowDialog(false)}
        onSave={handleModalSave}
        type={dialogType}
        chat={currentChat}
        loading={loading}
      />
      {/* ✅ Modal de informações do chat */}
      <ChatInfoModal
        open={showChatInfo}
        chat={currentChat}
        onClose={() => actions.toggleChatInfo()}
        onChatUpdate={handleChatUpdate}
      />

      <Paper
        className={
          isHorizontal ? classes.mainContainerHorizontal : classes.mainContainer
        }
      >
  {isWidthUp("md", props.width) ? renderGrid() : renderMobile()}
      </Paper>
    </>
  );
};

export default withWidth()(Chat);